import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import getItineraryEndpointPath from '@/src/utils/rtkQuery/getItineraryEndpointPath'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// You can import types as needed
// import { ItineraryConfirmResponse } from '@/src/types/itinerary';

export const bookConfirmApi = createApi({
    reducerPath: 'bookConfirmApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: headers => {
            return setCommonHeaders(headers)
        }
    }),
    endpoints: builder => ({
        getBookConfirm: builder.query<any, string>({
            query: itineraryId => getItineraryEndpointPath(itineraryId, `/itin/itinerary/${itineraryId}/appConfirm`)
        })
    })
})

export const { useGetBookConfirmQuery, useLazyGetBookConfirmQuery } = bookConfirmApi

export default bookConfirmApi
